import { createFileRoute } from '@tanstack/react-router';
import { InvitationAcceptPage } from '@/features/invitations';

/** Public: shows the invitation kept in this tab, then signs in or joins the organisation. */
export const Route = createFileRoute('/invitations/accept')({
  component: InvitationAcceptPage,
});
